import cx from "classnames";
import React, { type SyntheticEvent } from "react";
import type { FieldValues, UseFormRegister } from "react-hook-form";
import Loader from "../Loader";

type Props = {
  isLoading?: boolean;
  isDisabled?: boolean;
  className?: string;
  text: string;
  onClick?: (e: SyntheticEvent) => void;
};
type PropsWithValue = Props & {
  name: string;
  value: string;
  register: UseFormRegister<FieldValues>;
};

export function ButtonPrimary(props: Props | PropsWithValue) {
  const { isLoading = false, isDisabled = false, className, text } = props;

  let buttonWithValueProps;
  if ("value" in props && "name" in props && "register" in props) {
    const { value, name, register } = props;
    buttonWithValueProps = {
      ...register(name),
      name,
      value,
    };
  }
  return (
    <button
      disabled={isDisabled}
      type="submit"
      aria-label={text}
      className={cx(
        "relative flex items-center justify-center rounded-md border border-transparent bg-primary-600 px-5 py-3 text-base font-medium text-white shadow hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600 disabled:bg-primary-600/80 sm:px-10",
        className
      )}
      {...(buttonWithValueProps && buttonWithValueProps)}
    >
      {isLoading ? <Loader className="absolute" /> : null}
      <span className={cx({ invisible: isLoading })}>{text}</span>
    </button>
  );
}

export function ButtonSecondary(props: Props | PropsWithValue) {
  const { isLoading, isDisabled, className, text, onClick } = props;

  let buttonWithValueProps;
  if ("value" in props && "name" in props && "register" in props) {
    const { value, name, register } = props;
    buttonWithValueProps = {
      ...register(name),
      name,
      value,
    };
  }
  return (
    <button
      disabled={isDisabled}
      type="submit"
      aria-label={text}
      onClick={onClick}
      className={cx(
        "disabled:bg-white-100/80 relative flex items-center justify-center rounded-md border bg-white px-5 py-3 text-base font-medium text-primary-600 shadow hover:bg-primary-100",
        className
      )}
      {...(buttonWithValueProps && buttonWithValueProps)}
    >
      {isLoading ? <Loader className="absolute" /> : null}
      <span className={cx({ invisible: isLoading })}>{text}</span>
    </button>
  );
}
